import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTagRegularDiagonalIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 21",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.004 5.227c0-.416.334-.75.75-.75h4.878c.2 0 .39.078.531.218l6.5 6.5a.747.747 0 0 1 0 1.06l-4.878 4.88a.747.747 0 0 1-1.06 0l-6.5-6.5a.75.75 0 0 1-.218-.53zm.75-2.25a2.25 2.25 0 0 0-2.25 2.25v4.878c0 .597.237 1.168.66 1.59l6.5 6.5a2.25 2.25 0 0 0 3.18 0l4.879-4.878a2.25 2.25 0 0 0 0-3.181l-6.5-6.5a2.25 2.25 0 0 0-1.591-.66zm1.75 5a.999.999 0 1 0 0-2 .999.999 0 1 0 0 2" })
});
export default SvgTagRegularDiagonalIcon;
